import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { NavButtonComponent } from './nav-button.component';

@Component({
  selector: 'lassi-embedded-navbar',
  imports: [NavButtonComponent, MatDividerModule],
  template: `
    <div class="container">
      <lassi-nav-button [item]="layersTab" />
      <ng-content />
    </div>
  `,
  styles: `
    @use 'navbar' as *;

    @include navbar;

    .container {
      justify-content: center;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbeddedNavbarComponent {
  readonly layersTab = {
    name: 'layers',
    icon: 'page_info',
    label: 'Layers',
    id: 'layer_management',
  };
}
